export const ADMIN_GET_SIKAS = 'ADMIN_GET_SIKAS'
export const ADMIN_GET_SIKAS_NEED = 'ADMIN_GET_SIKAS_NEED'
export const ADMIN_GET_SIKAS_APP = 'ADMIN_GET_SIKAS_APP'
export const ADMIN_GET_SIKAS_REJ = 'ADMIN_GET_SIKAS_REJ'
export const ADMIN_ADD_SIKA = 'ADMIN_ADD_SIKA'
export const ADMIN_UPDATE_SIKA = 'ADMIN_UPDATE_SIKA'
export const ADMIN_UPDATE_SIKASTATUS = 'ADMIN_UPDATE_SIKASTATUS'
export const ADMIN_DELETE_SIKA = 'ADMIN_DELETE_SIKA'
